<template>
  <v-dialog
    v-model="localDialog"
    width="50%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
  >
    <base-card
      title="Sync Customer Balance"
      :v-card-text-class="'pa-4'"
    >
        <v-form @submit.prevent="submit" ref="SaleCustomerBalanceSummary">
          <v-row>
            <v-col lg="6" md="6" cols="12">
              <v-autocomplete
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="customer_id.value.value"
                :error-messages="customer_id.errorMessage.value"
                :items="getCustomerList"
                item-title="name"
                item-value="id"
                label="Customer"
                clearable
                :disabled="isDisabled"
              
                  :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                <template #label>
                  Customer <span class="text-red-accent-4">*</span>
                </template>
              </v-autocomplete>

              <v-autocomplete
                v-if="sale_invoice_master_id.value.value"
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="sale_invoice_master_id.value.value"
                :error-messages="sale_invoice_master_id.errorMessage.value"
                :items="getSaleInvoiceList"
                item-title="code"
                item-value="id"
                label="Sale Invoice"
                clearable
                :disabled="isDisabled"
              
                  :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

              <v-text-field
                  label="Old Invoice No"
                  density="compact"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  v-model="ref_no.value.value"
                  :error-messages="ref_no.errorMessage.value"
                  input-format="dd/mm/yyyy"
                  prepend-icon=""
                  clearable
              ></v-text-field>
            </v-col>

            <v-col lg="6" md="6" cols="12">
              <v-text-field
                label="Opening Balance"
                type="number"
                step="0.01"
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="opening_balance.value.value"
                :error-messages="opening_balance.errorMessage.value"
                clearable
              >
                <template #label>
                  Opening Balance <span class="text-red-accent-4">*</span>
                </template>
              </v-text-field>

              <v-date-input
                  label="Old Invoice Date"
                  density="compact"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  v-model="opening_date.value.value"
                  :error-messages="opening_date.errorMessage.value"
                  input-format="dd/mm/yyyy"
                  prepend-icon=""
                  prepend-inner-icon="mdi mdi-calendar-month"
                  clearable
              >
                <template #label>
                  Invoice Date <span class="text-red-accent-4">*</span>
                </template>
              </v-date-input>
            </v-col>
          </v-row>

          <v-divider></v-divider>
          <v-card-actions>
            <v-layout class="justify-end">
              <v-btn
                class="bg-red"
                variant="flat"
                type="reset"
                @click="closeDialog"
                >Close</v-btn
              >
              <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                Save
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-form>
    </base-card>
  </v-dialog>
</template>

<script>
import {computed, ref, watch} from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import baseCard from "@/components/utils/baseCard.vue";

export default {
  name: "SaleCustomerBalanceSummary",
  components: {
    baseCard,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({
        customer_id: null,
        opening_date: "",
        opening_balance: null,
        ref_no: null,
        sale_invoice_master_id: null,
      }),
    },
  },
  data() {
    return {
      localDialog: this.dialog,
      isEntryMode: true,
      isDisabled: false,
    };
  },
  watch: {
    dialog(val) {
      this.localDialog = val;
    },
    localDialog(val) {
      this.$emit("update:dialog", val);
    },
    data: {
      handler(newData) {
        this.isEntryMode = !newData.id;
        this.isDisabled = !!(newData.customer_id && newData.sale_invoice_master_id);
        this.resetForm({ errors: {}, touched: {} });
        this.customer_id.setValue(newData.customer_id || null, false);
        this.opening_date.setValue(newData.opening_date || "", false);
        this.opening_balance.setValue(newData.opening_balance || null, false);
        this.ref_no.setValue(newData.ref_no || null, false);
        this.sale_invoice_master_id.setValue(newData.sale_invoice_master_id || null, false);
      },
    },
  },
  created() {
    // if(this.$store.getters.getCustomerList.length == 0){
      this.$store.dispatch('getCustomerList')
    // }
    // if(this.$store.getters.getSaleInvoiceList.length == 0){
      this.$store.dispatch('getSaleInvoiceList')
    // }
  },
  computed:{
    getCustomerList() {
      return this.$store.getters.getCustomerList;
    },
    getSaleInvoiceList() {
      return this.$store.getters.getSaleInvoiceList;
    }
  },
  methods: {
    updateDialog(val) {
      this.$emit("update:dialog", val);
    },
    closeDialog() {
      this.$emit("update:dialog", false);
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        customer_id: yup.number().required().label("Customer"),
        opening_date: yup.string().required().label("Opening Date"),
        opening_balance: yup.number().required().label('Opening Balance'),
        ref_no: yup.string().nullable().label().label('Ref No'),
        sale_invoice_master_id: yup.number().nullable().label('Sale Invoice'),
      }),
    });

    const customer_id = useField("customer_id");
    const opening_date = useField("opening_date");
    const opening_balance = useField("opening_balance");
    const ref_no = useField("ref_no");
    const sale_invoice_master_id = useField("sale_invoice_master_id");

    const submit = handleSubmit((values) => {
      const submitData = {
        customer_id: values.customer_id,
        opening_date: values.opening_date,
        opening_balance: values.opening_balance,
        ref_no: values.ref_no,
        sale_invoice_master_id: values.sale_invoice_master_id,
      };

      store
        .dispatch("saleCustomerBalanceSync", submitData)
        .then((response) => {
          toast.success("Customer Balance saved successfully");
          emit("update:dialog", false);
          store.dispatch("getSaleCustomerBalanceSummaryList")
        })
        .catch((error) => {
          const errorMsg = error.response?.data?.message || "Error saving Customer Balance";
          toast.error(errorMsg);
        });
    });

    return {
      customer_id,
      opening_date,
      opening_balance,
      ref_no,
      sale_invoice_master_id,
      submit,
      resetForm,
    };
  },
};
</script>
